import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {useSelector} from 'react-redux';
import { Section } from "@components/organisms";

const useStyles = makeStyles(theme => ({
    sectionNoPaddingTop: {
        paddingTop: 0,
      },
      promoSection: {
        background: theme.palette.alternate.main,
        padding: theme.spacing(2, 2),
        [theme.breakpoints.up("md")]: {
          padding: theme.spacing(4, 2),
        },
      },
      purpleStripes: {
        color: "white",
        background:
          "repeating-linear-gradient(-55deg, #606dbc, #606dbc 10px, #465298 10px, #465298 20px)",
      },
      blueStripes: {
        color: "white",
        background:
          "repeating-linear-gradient(-55deg, #1788cf, #1788cf 15px, #0076bd 15px, #0076bd 30px)",
      },
      blueStripesThin: {
        color: "white",
        background:
          "repeating-linear-gradient(-55deg, #1788cf, #1788cf 10px, #0076bd 10px, #0076bd 20px)",
      },
      blueStripesGradient: {
        color: "white",
        background: "linear-gradient(90deg, rgba(79,154,201,1) 47%, rgba(11,82,125,1) 100%)", //4f9ac9 & 0b527d
      }
}));

/**
 * Component to display the sections
 *
 * @param {Object} props
 */
const ProfileBanner = props => {
  const { user } = useSelector(state => state.user);

  const classes = useStyles();

  return (
    <Section
    className={[classes.promoSection, classes.blueStripesThin]}
    fullWidth={true}
    disablePadding={true}
  >
    <Section disablePadding={true}>
      <h1>Hello {user.firstName} {user.lastName} ({user.employeeNumber})</h1>
    </Section>
  </Section>
  );
};


export default ProfileBanner;
